import { SettingsTranslationRequestDto } from './settings-translation-request-dto.interface';

export interface SettingsTranslationRequest {
    currencies: SettingsTranslationRequestDto[];
    locale: string;
    targetLocales: string[];
}
